import React, { useState } from "react";
import { IOptionProps } from "@atoms/ZSelect/interface";
import { IClientSelectProps } from "./interface";

import { Client, ClientsRequest } from "@/Contracts/Clients";
import { getClients } from "@/Services/Clients";
import ZDynamicSelect from "@molecules/ZDynamicSelect";
import { useFeatureFlag } from "@/Hooks";
import {
	GlobalSearchEntityType,
	GlobalSearchRequest
} from "@/Contracts";
import { getGlobalSearch } from "@/Utils";

const ZClientSelect: React.FC<IClientSelectProps> = props => {
	const {
		defaultOptions,
		clientFilters,
		limit,
		selectedIds,
		childHydrationParams,
		onChange,
		filterClients,
		...rest
	} = props;

	const useAtlasSearchFlag = useFeatureFlag("use_atlas_search");

	const formattedDefaultOptions =
		defaultOptions?.map(currOption => ({
			name: currOption.name,
			value: currOption.id
		})) ?? [];

	const [clients, setClients] = useState<Client[]>([]);

	const searchClients = async (value: string) => {
		if (
			useAtlasSearchFlag &&
			!clientFilters?.length &&
			!childHydrationParams?.length &&
			!selectedIds &&
			value
		)
			try {
				const globalSearchRequest = new GlobalSearchRequest(
					value,
					[GlobalSearchEntityType.Client],
					limit ?? 50,
					null,
					useAtlasSearchFlag,
					childHydrationParams
				);
				const response = await getGlobalSearch(globalSearchRequest);

				setClients(response.data.map(option => option.obj as Client));
			} catch (error) {
				console.error(error);
			}
		else {
			try {
				const opportunityRequest = new ClientsRequest(
					clientFilters ?? [],
					value,
					limit ?? 50,
					childHydrationParams ?? [],
					undefined,
					selectedIds
				);

				const response = await getClients(opportunityRequest);
				setClients(response.data);
			} catch (error) {
				console.error(error);
			}
		}
	};

	const filteredClients = filterClients ? filterClients(clients) : clients;

	const handleChange = (value: string) => {
		onChange?.(
			value,
			filteredClients.find(client => client.id === value)
		);
	};

	const options: IOptionProps[] = filteredClients.map(client => ({
		name: client.name,
		value: client.id
	}));

	return (
		<ZDynamicSelect
			defaultOptions={formattedDefaultOptions}
			fetchData={searchClients}
			options={options}
			onChange={handleChange}
			{...rest}
		/>
	);
};

export default ZClientSelect;
